"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Wire contracts shared by the backend and the three frontends.
 *
 * Imports nothing internal. Zod and TypeScript only, enforced by the zone rule.
 * See docs/self-hosted/engineering.html section 18.
 */
__exportStar(require("./problem-details"), exports);
__exportStar(require("./guest"), exports);
__exportStar(require("./upload"), exports);
__exportStar(require("./api"), exports);
__exportStar(require("./embed"), exports);
//# sourceMappingURL=index.js.map